import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';

export const CardContainer = styled('div', {
  dynamic: ({ cssProps: { isWidget } = {} }) => ({
    ...(isWidget
      ? {
          borderTop: '1px solid $cardBorder',
          borderBottom: '1px solid $cardBorder',
          marginBottom: '8px',
          backgroundColor: 'white',
        }
      : {}),
  }),
  backgroundColor: '#FAFCFF',
});

export const ContentContainer = styled('div', {
  dynamic: ({ cssProps: { isWidget } = {} }) => ({
    ...(isWidget ? { width: '100%' } : {}),
  }),
  borderWidth: '0.5px',
  borderColor: '#CBCCCD',
  borderStyle: 'solid',
  width: '196px',
  borderRadius: '8px',
  padding: '16px',
  '@media (max-width: 744px)': {
    alignItems: 'flex-start',
  },
});

export const PercentageBox = styled('div', {
  width: '98px',
  height: '76px',
  backgroundColor: '#007000',
  borderRadius: '16px',
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'center',
  '@media (max-width: 744px)': {
    width: '91px',
  },
});

export const PercentageText = styled(Heading, {
  color: 'white',
  fontSize: '36px !important',
  fontWeight: '700 !important',
  fontFamily: '$primary !important',
  lineHeight: '48px !important',
  '@media (max-width: 744px)': {
    fontWeight: 600,
    fontSize: '30px !important',
  },
});

export const CardSubContainer = styled('div', {
  dynamic: ({ cssProps: { isWidget } = {} }) => ({
    ...(isWidget ? { width: '100%' } : {}),
  }),
  marginTop: 0,
  borderWidth: '0.5px',
  borderColor: '#CBCCCD',
  borderStyle: 'solid',
  width: '850px',
  borderRadius: '8px',
  padding: '16px',
  backgroundColor: 'white',
  '@media (max-width: 984px)': {
    width: '100%',
    alignItems: 'flex-start',
  },
  '.desc-text': {
    color: '$core.color.neutral.80',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: '$primary',
    lineHeight: '18px',
    '@media (max-width: 744px)': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '18px',
    },
  },
  '.abyss-card-root': {
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    paddingTop: '$md',
    paddingBottom: '$md',
    display: 'flex',
    '@media (max-width: 744px)': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
});

export const CriteriaContentContainer = styled('div', {
  marginTop: '4px',
  marginBottom: '16px',
  height: '40px',
});

export const ContentTitle = styled(Text, {
  color: '$core.color.neutral.90',
  fontSize: '16px',
  fontWeight: 700,
  fontFamily: '$primary',
  lineHeight: '18px',
});

export const ContentValue = styled(Text, {
  fontSize: '14px !important',
  fontWeight: 700,
  paddingTop: '2px',
  paddingBottom: '2px',
  paddingLeft: '8px',
  paddingRight: '8px',
  borderRadius: '4px',
  fontFamily: '$primary',
  lineHeight: '18px',
});

export const ViewMoreText = styled(Text, {
  color: '$core.color.neutral.90',
  fontSize: '14px !important',
  fontWeight: 590,
  fontFamily: '$primary',
});

export const RightContainer = styled('div', {
  marginLeft: '24px',
  width: '85%',
  '.smart-choice-text': {
    fontFamily: '$primary',
    lineHeight: '32px',
    color: '$core.color.neutral.90 !important',
    marginRight: '16px',
    fontWeight: 700,
  },
});

export const VisuallyHidden = styled('span', {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
});
